<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
    </div>

    <div closable class="cursor-pointer profile">
      <div class="con-img ml-3">
        <div class="profile-header-image">
          <img
            v-if="activeUserInfo.photoURL"
            key="onlineImg"
            :src="activeUserInfo.photoURL"
            alt="user-img"
            lass="img-fluid"
          />
        </div>
      </div>

      <div class="menu-list">
        <div class="menu-space" />
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer profile-list"
            @click="$router.push({ name: 'franchise-profile' }).catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          <vs-divider class="m-1" />
          <li class="flex py-2 px-4 cursor-pointer logout-list" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {};
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    logout() {
      // if user is logged in via firebase
      const firebaseCurrentUser = firebase.auth().currentUser;

      if (firebaseCurrentUser) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.$router.push('/login').catch(() => {});
          });
      }

      // If JWT login
      if (
        localStorage.getItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}AccessToken`
        )
      ) {
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}AccessToken`
        );
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`
        );
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}TokenExpiry`
        );
        localStorage.removeItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`);
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}LoggedIn`
        );
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}RefreshToken`
        );
        this.$cookies.remove(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}RefreshToken`
        );
        localStorage.removeItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`);
        localStorage.removeItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
        );
        this.$router.push('/login').catch(() => {});
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('admin');
      localStorage.removeItem('userInfo');

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/login').catch(() => {});
    },
  },
};
</script>

<style scoped>
.menu-list {
  display: none;
  position: absolute;
  border: 1px solid #e3eae8;
  background-color: white;
  border-radius: 5px;
  top: 50px;
  right: 0;
}
.menu-list:before {
  content: "";
  position: absolute;
  top: -10px;
  width: 0;
  height: 0;
  right: 10px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid#e3eae8;
  clear: both;
}
.menu-list:after {
  content: "";
  position: absolute;
  top: -8px;
  right: 12px;
  width: 0;
  height: 0;
  border-bottom: 8px solid white;
  clear: both;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
.menu-space {
  position: absolute;
  width: 100%;
  height: 65%;
  top: -50px;
}
.profile {
  position: relative;
}
.profile:hover .menu-list {
  display: block;
  z-index: 60000;
}
.profile-list:hover > span {
  color: white;
}
.profile-list:hover {
  background-color: #3dc9b3;
  border-radius: 4px 4px 0px 0px;
}
.profile-list:hover .menu-list:after {
  border-bottom: 8px solid #3dc9b3;
  content: "";
  position: absolute;
  top: -8px;
  right: 12px;
  width: 0;
  height: 0;
  /* border-bottom: 8px solid white; */
  clear: both;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
.logout-list:hover > span {
  color: white;
}
.logout-list:hover {
  background-color: #3dc9b3;
  border-radius: 0px 0px 4px 4px;
}
</style>
